import { keyframes, Keyframes } from 'styled-components';

export const strokeDraw: Keyframes = keyframes`
  100% {
    stroke-dashoffset: 0;
  }
`;

export const scalePop: Keyframes = keyframes`
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

export const rotate360 = keyframes`
  0% {
      transform: rotate(0deg);
    }
  100% {
      transform: rotate(360deg);
    }
`;

export const slideInRight = (): Keyframes => keyframes`
from {
  transform: translateX(100%);
}

to {
  transform: translateX(0);
}`;

export const slideOutRight = (): Keyframes => keyframes`
from {
  transform: translateX(0);
}

to {
  transform: translateX(100%);
}`;

export const slideDownAndFade: Keyframes = keyframes`
from {
  opacity: 0;
  transform: translateY(-2px);
}
to {
  opacity: 1;
  transform: translateY(0);
}`;

export const slideLeftAndFade: Keyframes = keyframes`
from {
  opacity: 0;
  transform: translateX(2px);
}
to {
  opacity: 1;
  transform: translateX(0);
}`;

export const slideUpAndFade: Keyframes = keyframes`
from {
  opacity: 0;
  transform: translateY(2px);
}
to {
  opacity: 1;
  transform: translateY(0);
}`;

export const slideRightAndFade: Keyframes = keyframes`
from {
  opacity: 0;
  transform: translateX(-2px);
}
to {
  opacity: 1;
  transform: translateX(0);
}`;
